import React from 'react';
import ReactDOM from 'react-dom'
import { ApolloClient, ApolloProvider, createNetworkInterface } from 'react-apollo'
import App from './app'
//import config from './config'
import getSession from './session'
getSession()
//console.log('sessionId', sessionId)

const client = new ApolloClient({
  networkInterface: createNetworkInterface({ uri: 'https://api.graph.cool/simple/v1/cj2ujqg8tm4r301694l41kihi'}),
  dataIdFromObject: o => o.id
})


ReactDOM.render(

    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js